<!-- Main Page Start -->

<div class="content-wrapper table-full-bx groups-permissions manage-users">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">

                        <div class="page-heading slash_breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a routerLink="/groups"> Groups and Permissions </a></li>
                                <li class="breadcrumb-item"><a (click)="goToBack()"> Manage Users </a> </li>
                                <li class="breadcrumb-item"> Add Users to Group </li>
                            </ol>
                        </div>

                        <div class="flexbox">
                            <div class="iboxcontent">
                                <h3 class="pb-1"> Add User(s) to Group : Recruiter </h3>
                            </div>

                            <div class="input-group-icon input-group-icon-left">
                                <div class="col-list-right">
                                    <form (ngSubmit)="searchFun()">
                                        <div class="form-group">
                                            <span class="input-icon input-icon-right font-16" (click)="searchFun()"><img src="assets/images/search.svg"></span>
                                            <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid search" name="search" id="key-search" placeholder="Search Id,Name,Email" />
                                            <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <!-- end -->

                        <!-- Table -->
                        <div class="table-scroll table-wrapper smalltab table-responsive">
                            <table id="example" class="table table-bordered table-hover m-0  " style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>Select </th>
                                        <th>ID </th>
                                        <th>Full name </th>
                                        <th class="width-auto">Email ID </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- 1 -->
                                    <tr *ngFor="let data of usersData;let i=index">
                                        <td>
                                            <a href="javascript:void(0);">
                                                <div class="checkboxWrap" (click)="getIds(i)">
                                                    <input type="checkbox" 
                                                    [checked]="data?.select == 0 ? true : false"/> 
                                                    <label for="checkbox1"> </label>
                                                </div>
                                            </a>
                                        </td>

                                        <td><a href="javascript:void(0);">{{data?.id}} </a></td>
                                        <td class="td-linked">
                                            <a (click)="goToUserDetail(data?.id)" class="jobid linkedIn">{{data?.fullName}} </a>
                                            <i class="icons"><img (click)="goToLinkedInUrl(data?.linkedin)" *ngIf="data?.linkedin" src="assets/images/ic_linkedin-logo.svg"></i>
                                        </td>
                                        <td class="width-auto"><a href="javascript:void(0);" > {{data?.email}} </a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="noDataFound" *ngIf="usersData.length == 0">
                            <h2>No Records Found</h2>
                        </div>

                        <!--  pagination  -->
                        <div class="col-sm-12 p-0" *ngIf="usersData.length > 9">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                            </ul>
                        </div>
                        <!-- end -->

                        <div class="form-group btnwrap" >
                            <input value="Cancel" name="" class="common-btn unfill" type="submit" (click)="goToBack()"/>
                            <input value="Add User" name="" class="common-btn" type="submit" (click)="updateUsers()"/>
                        </div>
                        <div class="text-danger" *ngIf="showError">
                            Please add users from user tab and then add into the group. 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End -->